import React from 'react';
import styled from 'styled-components';
import theme from '../../../assets/css/theme';

const Wrapper = styled.section`
  &:not(:last-child) {
    padding-bottom: 40px;
    margin-bottom: 30px;
    border-bottom: 1px solid #e5e5e5;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 16px;
`;

const IconWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 24px;
  height: 24px;
  margin-right: 12px;
  color: ${theme.commonColors.main};

  svg {
    width: 22px;
    height: 22px;
  }
`;

const Titles = styled.div`
  display: flex;
  flex-direction: column;
`;

// `!important` is needed to beat the global `h2 { font-size/font-weight: !important }`
// rule in _custom.scss; the element stays an h2 so the panel keeps its heading semantics.
const Title = styled.h2`
  margin: 0;
  font-size: ${theme.fontSizes.title} !important;
  font-weight: 500 !important;
  line-height: 1.2;
  color: ${theme.commonColors.main};
`;

const Subtitle = styled.span`
  margin-top: 4px;
  font-size: ${theme.fontSizes.small};
  color: #9a9a9a;
`;

interface IProps {
  /** SVG imported with the `?react` svgr suffix */
  icon?: React.FC<React.SVGProps<SVGSVGElement>>;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  className?: string;
}

export const SettingsSection = ({ icon: Icon, title, subtitle, children, className }: IProps) => (
  <Wrapper className={className}>
    <Header>
      {Icon && (
        <IconWrapper>
          <Icon />
        </IconWrapper>
      )}
      <Titles>
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </Titles>
    </Header>
    {children}
  </Wrapper>
);

export default SettingsSection;
